import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './pages/menu/menu.component';
import { TestRoutingModule} from './test-routing.module';
import { SplashScreenComponent } from '../app/views/partials/layout';
import { SharedModule } from '../shared/shared.module';
import { PartialsModule } from '../app/views/partials/partials.module';
import { MatProgressSpinnerModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatTableModule, MatPaginatorModule, MatSortModule, MatIconModule, MatButtonModule, MatCheckboxModule } from '@angular/material';
import { LayoutConfigService, SplashScreenService, LayoutRefService, MenuConfigService, PageConfigService, KtDialogService, DataTableService, SubheaderService, MenuHorizontalService, MenuAsideService } from '../app/core/_base/layout';
import { TestComponent } from './test.component';
import { BaseComponent } from '../app/views/theme/base/base.component';
import { ThemeModule } from '../app/views/theme/theme.module';
import { StoreFeatureModule, StoreModule } from '@ngrx/store';
import { OverlayModule } from '@angular/cdk/overlay';
import { reducers, metaReducers } from '../app/core/reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthService } from '../app/core/auth';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { HttpUtilsService, TypesUtilsService, LayoutUtilsService } from '../app/core/_base/crud';
import { ServiceProxyModule } from '../shared/service-proxies/service-proxy.module';
import { NgxPermissionsService } from 'ngx-permissions';
import { TranslateService } from '@ngx-translate/core';

import { CoreModule } from '../app/core/core.module';
import { AuthNoticeComponent } from './../app/views/pages/auth/auth-notice/auth-notice.component';
import { AuthModule } from './../app/views/pages/auth/auth.module';
import { NgbModule, NgbTooltip, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { CustomModalComponent } from './pages/custom-modal/custom-modal.component';
import { Component1Component } from './pages/component1/component1.component';
import { LoginService } from './service/login.service';
import { InfoModalComponent } from './pages/info-modal/info-modal.component';
import { CustomMessageService } from '../shared/service-proxies/custom-message.service';

import { UserEditComponent } from './pages/users/user-edit/user-edit.component';
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { ExcelService } from './service/excel.service';
import { Component2Component } from './pages/component2/component2.component';
import { LoadingComponent } from './pages/loading/loading.component';
import { SubTestModule } from './sub-test/sub-test.module';
import { MenuCardComponent } from './../app/views/partials/layout/menu-card/menu-card.component';
import { DirectiveModule } from './../app/views/pages/transpop/shared/directives/directive.module';
import { IframeComponent } from './pages/iframe/iframe.component';
import { StickyMenuComponent } from './sticky-menu/sticky-menu.component';




@NgModule({
  declarations: [
    MenuComponent,
    TestComponent,
    CustomModalComponent,
    Component1Component,
    
    UserEditComponent,
    UserListComponent,
    Component2Component,
	LoadingComponent,
	MenuCardComponent,
	IframeComponent,
	StickyMenuComponent,
	
	//MenuCardComponent,
   // InfoModalComponent,
	//AuthNoticeComponent,
   
    
  ],
  imports: [
	DirectiveModule,
	NgbModule,
 	CommonModule,
	CoreModule,
	
	TestRoutingModule,
	
    PartialsModule,
    ServiceProxyModule,

    MatProgressSpinnerModule,
    
    SharedModule,
    ThemeModule,
    StoreFeatureModule,
	AuthModule,
	OverlayModule,

	MatFormFieldModule,
	MatInputModule,
	MatTableModule,
	MatPaginatorModule,
	MatSortModule,
	MatProgressSpinnerModule,
	MatSelectModule,
	MatIconModule,
	MatButtonModule,
	MatCheckboxModule,
	
	//SubTestModule, --Burada oldugunda, test module de calismiyo!

	/* 	StoreModule.forRoot(reducers, {metaReducers}),
		EffectsModule.forRoot([]),
		StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
		StoreDevtoolsModule.instrument(), */
    
  ],
  exports:[
	//ExcelService
	 // InfoModalComponent
  ],
  providers: [
    AuthService,
   
		LayoutConfigService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		KtDialogService,
		DataTableService,
		ExcelService,
		
		/*{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: GestureConfig
		},*/
		
		// template services
		SubheaderService,
		MenuHorizontalService,
		MenuAsideService,
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		LoginService,
		CustomMessageService,
		
  
  ],
  entryComponents : [
	  CustomModalComponent,
	  //InfoModalComponent
  ]
})
export class TestModule { }
